(() => {
  const initialize = () => document.querySelectorAll('[data-nh-reviews]').forEach(section => {
    const button = section.querySelector('[data-nh-reviews-toggle]');
    if (!button || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    button.hidden = false;
    section.dataset.reviewEnhancement = 'true';
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      section.dataset.reviewsExpanded = String(expanded);
      button.textContent = expanded ? 'Vis færre anmeldelser' : 'Læs alle anmeldelser';
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
